export default function CloseRoundedIcon({ size = 26, color = 'currentColor', filled: _1, ...props }: IconProps) {
  return (
    <svg width={size} viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="13" cy="13" r="13" fill={color} />
      <path d="M9 16.9999L17 8.99994" stroke="white" strokeWidth="2" />
      <path d="M17 17.0004L9 9.00043" stroke="white" strokeWidth="2" />
    </svg>
  );
}
